import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { Debit } from 'interfaces';
import { useState } from 'react';
import { DebitCard } from './DebitCard';

interface DebitsModalProps {
  opened: boolean;
  close: () => void;
  debits: Debit[];
}

export const DebitsModal: React.FC<DebitsModalProps> = ({
  opened,
  close,
  debits,
}) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  const totalDebits = debits.length;
  const totalPages = Math.ceil(totalDebits / itemsPerPage);

  const currentDebits = debits.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setPage(1);
        close();
      }}
      title="Debits"
      fullScreen
      withCloseButton
      withOverlay
    >
      {totalDebits > 0 ? (
        <Stack gap={'md'}>
          {currentDebits.map((debit) => (
            <DebitCard debit={debit} key={debit.id} />
          ))}
          <Group align="center" mt="md" w="100%" justify="center">
            <Button onClick={handlePreviousPage} disabled={page === 1}>
              Previous
            </Button>
            <Text>
              Page {page} of {totalPages}
            </Text>
            <Button onClick={handleNextPage} disabled={page === totalPages}>
              Next
            </Button>
          </Group>
        </Stack>
      ) : (
        <Text size="sm">No debits found for this statement.</Text>
      )}
    </Modal>
  );
};
